import { render, staticRenderFns } from "./ExtForm.vue?vue&type=template&id=19db7500&"
import script from "./ExtForm.vue?vue&type=script&lang=js&"
export * from "./ExtForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports